import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { appState } from "$reducers";
import useAuth from "$hooks/useAuth";
import { CompanyType } from "$types/CompanyType";
import CompanySelect from "$forms/CompanySelect";
import { useStyles } from "./Stock.styles";

export const StockCompanySelect = () => {
  const { filter: companySidebarFilter } = useSelector(appState);
  const { isAdmin, isContributor: isUserContributor } = useAuth();
  const navigate = useNavigate();
  const params = useParams<any>();
  const { idCompany: companyParamId } = params;
  const classes = useStyles();

  const goToStockOf = useCallback(
    (companyId: string) => {
      navigate(`/stock${companyId ? `/${companyId}` : ""}`);
    },
    [navigate]
  );

  // Watch sidebar filter change to impact the select (change url)
  useEffect(() => {
    if (companySidebarFilter?._id) {
      goToStockOf(companySidebarFilter?._id);
    }
  }, [companySidebarFilter?._id, goToStockOf]);

  if (!isAdmin() && !isUserContributor()) return null;

  return (
    <Box display="flex" flex={1} justifyContent="flex-end">
      <Box width={300}>
        <CompanySelect
          className={classes.select}
          disabled={!!companySidebarFilter && isAdmin()}
          companyTypes={[
            CompanyType.CLIENT,
            // CompanyType.CONTRIBUTOR,
            // CompanyType.LOGISTICIAN,
          ]}
          activeCompaniesOnly
          ignoreSideBarCompanyFilter
          label="Sélectionnez une entreprise"
          minCharsToTrigerSearch={0}
          rowsPerPage={99999}
          onChange={(newCompanyId) => goToStockOf(newCompanyId)}
          value={companyParamId}
        />
      </Box>
    </Box>
  );
};
